export enum DevicePlatform {
  WEB = 'web',
  APP = 'app',
}
